/**
 * Traductions des noms de paramètres en français
 * Utilisé pour afficher les noms techniques en français dans l'interface
 */
export const parametersFr: { [key: string]: string } = {
  // Paramètres de suivi du Coran
  'targetRepeatNewHifzCount': 'Répétition du nouveau Hifz',
  'repeatOldHifzCount': 'Répétition de l\'ancien Hifz',
  'repeatReviewCount': 'Répétition de révision',
  'dailyGoal': 'Objectif quotidien',
  'weeklyGoal': 'Objectif hebdomadaire',
  'monthlyGoal': 'Objectif mensuel',
  
  // Paramètres de permissions
  'allowTeacherToAddExamPoints': 'Autoriser l\'enseignant à ajouter des points d\'examen',
  
  // Paramètres de validation
  'checkEmailUniquenessForUsers': 'Vérifier l\'unicité des adresses e-mail des utilisateurs',
  
  // Paramètres généraux
  'applicationName': 'Nom de l\'application',
  'organizationName': 'Nom de l\'organisation',
  'contactEmail': 'E-mail de contact',
  'contactPhone': 'Téléphone de contact',
  'address': 'Adresse',
  
  // Paramètres académiques
  'academicYearStart': 'Début de l\'année scolaire',
  'academicYearEnd': 'Fin de l\'année scolaire',
  'maxStudentsPerClass': 'Nombre maximum d\'étudiants par classe',
  'minAttendancePercentage': 'Pourcentage minimum de présence',
  
  // Paramètres financiers
  'monthlyFee': 'Frais mensuels',
  'annualRegistrationFee': 'Frais d\'inscription annuels',
  'lateFeePercentage': 'Pourcentage de frais de retard',
  
  // Paramètres de notification
  'enableEmailNotifications': 'Activer les notifications par e-mail',
  'enableSmsNotifications': 'Activer les notifications par SMS',
  'notificationLanguage': 'Langue des notifications',
  
  // Fuseau horaire
  'default_timezone': 'Fuseau horaire de l\'association',

  // Paramètres système
  'maintenanceMode': 'Mode maintenance',
  'apiTimeout': 'Délai d\'attente API',
  'maxFileUploadSize': 'Taille maximale de fichier',
  'allowedFileTypes': 'Types de fichiers autorisés',
};

/**
 * Fonction pour obtenir la traduction d'un nom de paramètre
 * @param parameterName - Le nom technique du paramètre
 * @returns La traduction en français ou le nom original si non trouvé
 */
export const getParameterNameFr = (parameterName: string): string => {
  return parametersFr[parameterName] || parameterName;
};
